import { render, staticRenderFns } from "./FormCreateTeam.vue?vue&type=template&id=3b59996e&"
import script from "./FormCreateTeam.vue?vue&type=script&lang=js&"
export * from "./FormCreateTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports